export default {
  info: '#6FCFEB',
  primary: '#60269E',
  success: '#60269E',
  warning: '#f68e56',
  danger: '#EB0045',
}
